import { Badge } from "@design";
import { Lock } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { SpaceResourceResponse } from "@/api";
import { Text } from "@/components/Text";

/** "Only you" on my private items. */
export function OnlyYouBadge({ item }: Readonly<{ item: SpaceResourceResponse }>) {
  const { t } = useTranslation("spaces", { keyPrefix: "detail.pinned" });
  if (item.visibility !== "private") return null;
  return (
    <Badge variant="neutral" size="compact" icon={<Lock size={10} />}>
      {t("onlyYou")}
    </Badge>
  );
}

/** Shown when a shared item points to something I can't use (a space never grants access). */
export function NoAccessNote({ item }: Readonly<{ item: SpaceResourceResponse }>) {
  const { t } = useTranslation("spaces", { keyPrefix: "detail.pinned" });
  if (item.canUse !== false) return null;
  return (
    <Text variant="caption" tone="warning" className="mt-1">
      {t("noAccess")}
    </Text>
  );
}
